import Brain from './Brain';

export default Brain;
